import { Button, makeStyles } from '@material-ui/core';
import { ArchiveRounded as ArchiveIcon, UnarchiveRounded as UnarchiveIcon } from '@material-ui/icons';

import { Segment } from '../../types/segment.type';
import SegmentCategoryChip from '../Chips/SegmentCategoryChip.component';
import StatusChip from '../../../shared/components/Chips/StatusChip.component';

type Props = {
  segment: Segment;
  onArchiveActionClick: () => void;
};

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > h2': {
      margin: 0,
    },
  },

  archiveButton: {
    marginLeft: 'auto',
    textTransform: 'none',
  },
});

export function SegmentDetailsHeader({ segment, onArchiveActionClick }: Props) {
  const classes = useStyles();
  const isArchived = Boolean(segment.archivedAt);

  return (
    <div className={classes.header}>
      <h2>{segment.name}</h2>
      <SegmentCategoryChip category={segment.category} />
      <StatusChip isActive={segment.isActive} archived={isArchived} />
      <Button
        size="small"
        variant="outlined"
        className={classes.archiveButton}
        startIcon={isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
        onClick={onArchiveActionClick}
      >
        {isArchived ? 'Restaurer' : 'Archiver'}
      </Button>
    </div>
  );
}
